import React from 'react'
import { DataTable } from '../widgets';

export default function ImportShapeList({ isavailableShapes, newRegions }) {
    let shapes = [];
    for (const region of newRegions) {
        shapes.push(...region.shapes)
    }
    return (
        <>
            <DataTable className="mb-3">
                <DataTable.Header>
                    <DataTable.Row>
                        <DataTable.Cell style={{ width: "40px" }} >#</DataTable.Cell>
                        <DataTable.Cell>Region/Shape</DataTable.Cell>
                    </DataTable.Row>
                </DataTable.Header>
                <DataTable.Body>
                    {
                        !isavailableShapes ? <DataTable.Row >
                            <DataTable.Cell colSpan="2" className="text-center" > <div>No region/shape found</div> </DataTable.Cell>
                        </DataTable.Row> : shapes.map((shape, index) => (
                            <DataTable.Row key={index}>
                                <DataTable.Cell>{index + 1}</DataTable.Cell>
                                <DataTable.Cell> {shape.name} {shape.isAlready ? <span title='This region/shape name already exists' ><i className="fa fa-exclamation-triangle" style={{ color: "#f9c605" }} aria-hidden="true"></i></span> : <span></span>} </DataTable.Cell>
                            </DataTable.Row>
                        ))
                    }
                </DataTable.Body>
            </DataTable>
        </>
    )
}
